<template>
  <div class="font-style">
    <div
      v-for="(item, i) in items"
      class="item"
      :class="{active: isActive(item)}"
      :key="i"
      @click="select(item)"
    >{{item.text}}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      items: [
        { text: 'B' },
        { text: 'I' },
        { text: 'U' },
      ]
    }
  },
  computed: {
    ...mapGetters({
      subtitle: 'subtitle/selectSubtitle'
    }),
  },
  methods: {
    isActive (item) {
      if (this.subtitle && item.text === 'B') {
        return this.subtitle.font.fontWeight === 'bold'
      }
      if (this.subtitle && item.text === 'I') {
        return this.subtitle.font.fontStyle === 'italic'
      }
      if (this.subtitle && item.text === 'U') {
        return this.subtitle.font.textDecoration === 'underline'
      }
    },
    select (item) {
      if (this.subtitle) {
        switch (item.text) {
          case 'B':
            this.toggleBold();
            break;
          case 'I':
            this.toggleItalic();
            break;
          case 'U':
            this.toggleUnderline();
            break;
          default:
            break;
        }
      }
    },
    toggleBold () {
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: {
          font: {
            fontWeight: this.subtitle.font.fontWeight === 'normal' ? 'bold' : 'normal'
          }
        }
      });
    },
    toggleItalic () {
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: {
          font: {
            fontStyle: this.subtitle.font.fontStyle === 'normal' ? 'italic' : 'normal'
          }
        }
      });
    },
    toggleUnderline () {
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: {
          font: {
            textDecoration: this.subtitle.font.textDecoration === 'none' ? 'underline' : 'none'
          }
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.font-style {
  display: flex;
  align-items: center;
  width: 226px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #d9ddea;
  border-radius: 4px;
}
.item {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  cursor: pointer;
  height: 100%;
  &.active {
    color: #5778fb;
  }
}
.item:nth-of-type(1) {
  font-family: sans-serif !important;
  font-weight: 900;
}
.item:nth-of-type(2) {
  font-family: serif !important;
  font-style: italic;
  font-weight: 600;
  position: relative;
  &:before,
  &:after {
    content: ' ';
    width: 1px;
    height: 16px;
    background: #ffffff;
    background-color: #d9ddea;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  &:before {
    left: 0;
  }
  &:after {
    right: 0;
  }
}
.item:nth-of-type(3) {
  font-family: sans-serif !important;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel/fontStyle.vue